export const GeneralActionTypes={
    SET_RECENT_FETCHED_TIME:"SET_RECENT_FETCHED_TIME"
}